<template>
  <span class="dropdown d-print-none">
    <a v-if="!task.completed" data-toggle="dropdown">
      <i class="material-icons pointer custom-checkbox">check_box_outline_blank</i>
    </a>
    <a v-else>
      <i class="material-icons pointer text-primary custom-checkbox" @click="toggleCompleteStatus(task)">check_box</i>
    </a>

    <span class="dropdown-menu">
      <a class="dropdown-item pointer" @click="completeAndJournal(task)">Complete & Journal</a>
    </span>
  </span>
</template>

<script>
import api from "api";

export default {
  props: {
    task: {
      type: Object
    }
  },

  methods: {
    taskLabelId(task){
      return 'task-' + task.id
    },
    toggleCompleteStatus(task){
      api.toggleTaskStatus(task.id).then(response => {
      });
    },
    completeAndJournal(task){
      api.toggleTaskStatus(task.id, true).then(response => {
      });
    },
  }
}
</script>
